import { useGetMilkingParlorNames } from 'hook/query/useGetMilkingParlorNames'
import { useCallback, useMemo, useState } from 'react'

export const useMilkingParlorFilters = () => {
	const [selectParlors, setSelectParlors] = useState<(string | number)[]>([])
	const { data: parlorNames } = useGetMilkingParlorNames()

	const handleToggleParlor = useCallback((id: string | number) => {
		setSelectParlors(prev => {
			if (prev.includes(id)) {
				return prev.filter(item => item !== id)
			}
			return [...prev, id]
		})
	}, [])

	const handleRemoveParlor = useCallback((id: string | number) => {
		setSelectParlors(prev => prev.filter(item => item !== id))
	}, [])

	const tabs = useMemo(() => {
		if (!parlorNames?.items || !Array.isArray(parlorNames.items)) return []
		return parlorNames.items.map(el => ({
			title: el.name,
			key: el.id,
		}))
	}, [parlorNames])

	const availableParlors = useMemo(() => {
		return tabs
	}, [tabs])

	const parlorBreadcrumbs = useMemo(() => {
		return availableParlors.map(tab => ({
			id: tab.key,
			title: tab.title,
			selected: selectParlors.includes(tab.key),
			disabled: false,
		}))
	}, [availableParlors, selectParlors])

	const parlorId: number[] | 'all' = useMemo(() => {
		if (selectParlors.length === 0) return 'all'
		const validParlors = selectParlors.filter(
			parlor => typeof parlor === 'number',
		) as number[]
		return validParlors.length > 0 ? validParlors : 'all'
	}, [selectParlors])

	return {
		selectedParlors: selectParlors,
		handleToggleParlor,
		handleRemoveParlor,
		availableParlors,
		parlorBreadcrumbs,
		parlorId,
	}
}
